import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import AnimatedTagline from "./AnimatedTagline"

/**
 * Shared authentication shell: logo, marquee tagline, dark card with
 * title/subtitle, form slot, and footer.
 * - size="sm" 580px | size="lg" 700px (create account)
 * - compact / create for tighter card spacing on taller forms
 */
const AuthLayout = ({
  title,
  subtitle,
  children,
  size = "sm",
  compact = false,
  create = false,
  className = "",
}) => {
  useEffect(() => {
    document.body.className = "authentication-bg"
    return () => {
      document.body.className = ""
    }
  }, [])

  const contentClass = [
    "auth-page__content",
    size === "lg" ? "auth-page__content--lg" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ")

  const cardClass = [
    "auth-page__card",
    compact ? "auth-page__card--compact" : null,
    create ? "auth-page__card--create" : null,
  ]
    .filter(Boolean)
    .join(" ")

  return (
    <div className="auth-page">
      <div className="auth-page__logo">
        <Link to="/" className="auth-logo">
          <p className="logo">AMOK.EARTH</p>
        </Link>
      </div>

      <AnimatedTagline />

      <div className={contentClass}>
        <div className={cardClass}>
          {(title || subtitle) && (
            <div className="auth-page__header">
              {title ? <h5 className="auth-page__title">{title}</h5> : null}
              {subtitle ? (
                <p className="auth-page__subtitle">{subtitle}</p>
              ) : null}
            </div>
          )}
          {children}
        </div>
      </div>

      <footer className="auth-page__footer">
        <p className="auth-page__copyright">
          © Amok Earth {new Date().getFullYear()}. All Rights Reserved.
        </p>
      </footer>
    </div>
  )
}

AuthLayout.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["sm", "lg"]),
  compact: PropTypes.bool,
  create: PropTypes.bool,
  className: PropTypes.string,
}

export default AuthLayout
